'use strict';

import {ChoiceSelect} from '../../../../../plugins/levcharity/resources/scripts/components/ChoiceSelect'
import {DOM} from "../../../../../plugins/levcharity/resources/scripts/helpers/DOM";

export class CreateCampaign {
    constructor() {
        this.addEvents();
        this.uploadButtons();
        this.currencySwitcher();
        const choice = new ChoiceSelect();
        choice.singleSelect();

        this.initTShirtConditions();
    }

    addEvents() {
    }

    uploadButtons() {
        let buttons = document.querySelectorAll('button.upload-image-button-chaiathon');

        if (buttons) {
            buttons.forEach(button => {
                let eventAdded = false;
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    const form = button.closest('.form-group');
                    const fileInput = form?.querySelector('input[type="file"]');

                    if (fileInput) {
                        if (!eventAdded) {
                            eventAdded = true;
                            fileInput.addEventListener('change', () => {
                                let filesText = '';

                                if (fileInput.files.length > 1) {
                                    filesText = fileInput.files.length + 'Files'
                                } else {
                                    filesText = fileInput.files[0].name
                                }

                                button.dataset.files = filesText;

                            })
                        }

                        fileInput.value = '';
                        fileInput.click();
                    }
                });
            });
        }
    }



    currencySwitcher() {
        const select = document.querySelector('select.campaign-currency');
        const currencySymbolWrapper = document.querySelector('.campaign-currency-symbol');

        if (select && currencySymbolWrapper) {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption) {
                currencySymbolWrapper.textContent = selectedOption.dataset.symbol || '';
            }
            select.addEventListener('change', () => {
                const selectedOption = select.options[select.selectedIndex];
                if (selectedOption) {
                    currencySymbolWrapper.textContent = selectedOption.dataset.symbol || '';
                }
            });
        }
    }

    initTShirtConditions() {
        const handle = () => {
            const teamIdField = document.querySelector('[name="team_id"]');
            const teamId = teamIdField?.value;

            console.log(teamId)
            const tShirtWrapper = document.querySelector('.chaiathon_t_shirt_size');
            if (!tShirtWrapper) return;

            const tShirtField = tShirtWrapper.querySelector('select')

            const displayForTeams = (tShirtWrapper?.dataset?.display || '').split(',')

            if (displayForTeams.includes(teamId)) {
                tShirtWrapper.style.display = '';
                tShirtField.required = true
            } else {
                tShirtWrapper.style.display = 'none'
                tShirtField.required = false
            }
        }

        DOM.addEvent('change', 'select[name=team_id]', () => {
            handle();
        })
        handle();

    }

}
